'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

var _filter = require('lodash/filter');

var _filter2 = _interopRequireDefault(_filter);

var _remove = require('lodash/remove');

var _remove2 = _interopRequireDefault(_remove);

var _isEqual = require('lodash/isEqual');

var _isEqual2 = _interopRequireDefault(_isEqual);

var _size = require('lodash/size');

var _size2 = _interopRequireDefault(_size);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _DropdownButton = require('react-bootstrap/lib/DropdownButton');

var _DropdownButton2 = _interopRequireDefault(_DropdownButton);

var _MenuItem = require('react-bootstrap/lib/MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _VisibleSecondary = require('@scoir/brand-icons/dist/VisibleSecondary');

var _VisibleSecondary2 = _interopRequireDefault(_VisibleSecondary);

require('./TableColumnVisibility.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableColumnVisibility = function (_React$Component) {
    _inherits(TableColumnVisibility, _React$Component);

    function TableColumnVisibility() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, TableColumnVisibility);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TableColumnVisibility.__proto__ || Object.getPrototypeOf(TableColumnVisibility)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            open: false
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TableColumnVisibility, [{
        key: 'updateColumnVisibility',
        value: function updateColumnVisibility(key, isVisible) {
            var hiddenColumns = (0, _map2.default)((0, _filter2.default)(this.props.columnDefs, { display: false }), 'key');
            var canHide = (0, _size2.default)(this.props.columnDefs) - (0, _size2.default)(hiddenColumns) > 1;
            if (isVisible) {
                if (canHide) {
                    this.props.onChangeColumnVisibility([].concat(_toConsumableArray(hiddenColumns), [key]));
                }
            } else {
                var columns = (0, _remove2.default)(hiddenColumns, function (column) {
                    return !(0, _isEqual2.default)(column, key);
                });
                this.props.onChangeColumnVisibility(columns);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'column-visibility-comp' },
                _react2.default.createElement(
                    'span',
                    { className: 'column-visibility-results' },
                    'Results'
                ),
                _react2.default.createElement(
                    _DropdownButton2.default,
                    {
                        id: 'column-visibility-dropdown',
                        noCaret: true,
                        title: _react2.default.createElement(_VisibleSecondary2.default, null),
                        pullRight: true },
                    _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        (0, _map2.default)(this.props.columnDefs, function (column) {
                            if ((0, _get2.default)(column, 'canToggleVisibility', true)) {
                                return _react2.default.createElement(
                                    _MenuItem2.default,
                                    {
                                        key: column.key,
                                        onSelect: function onSelect() {
                                            return _this2.updateColumnVisibility(column.key, column.display);
                                        } },
                                    _react2.default.createElement(
                                        'label',
                                        { key: column.display ? 'checked' : 'not-checked' },
                                        _react2.default.createElement('input', { value: column.display || false, onChange: function onChange() {}, tabIndex: '-1', type: 'checkbox', checked: column.display || false }),
                                        '\xA0',
                                        column.headerText
                                    )
                                );
                            }
                        })
                    )
                )
            );
        }
    }]);

    return TableColumnVisibility;
}(_react2.default.Component);

TableColumnVisibility.propTypes = {
    columnDefs: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        key: _propTypes2.default.string.isRequired,
        display: _propTypes2.default.bool.isRequired,
        headerText: _propTypes2.default.string.isRequired,
        canToggleVisibility: _propTypes2.default.bool
    })),
    onChangeColumnVisibility: _propTypes2.default.func.isRequired
};

exports.default = TableColumnVisibility;
//# sourceMappingURL=TableColumnVisibility.js.map